export const VIEW_WITHOUT_CONTACTS = 'view_without_contacts';
export const EDIT = 'edit';
export const VIEW = 'view';
